'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sidebar from 'ContentEditorUI/components/sidebar/Sidebar';
import AppReadyContainer from 'ContentEditorUI/containers/AppReadyContainer';
import { getActiveSidebarPanel, getIsSidebarExpanded } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { closePanel } from 'ContentEditorUI/redux/actions/panelActions';
import { clearInpageUIState } from 'ContentEditorUI/redux/actions/inpageActions';
import { APPLY_CHANGES_PORTAL_SELECTOR } from 'ContentEditorUI/lib/sidebar/constants';
import { getSelectedModuleName } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { routeToPage as routeToPageAction } from 'ContentEditorUI/redux/actions/routingActions';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  selectedModuleName: getSelectedModuleName(state),
  isOpen: getIsSidebarExpanded(state),
  currentStep: getRoutingCurrentPage(state),
  isReadOnlyMode: getIsReadOnlyMode(state),
  hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state)
});
const mapDispatchToProps = {
  onClose: closePanel,
  clearInpageUIState,
  routeToPage: routeToPageAction
};
class SidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.handleClose = () => {
      const {
        onClose,
        activePanel
      } = this.props;
      onClose(activePanel);
      this.props.clearInpageUIState();
    };
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      applyChangesButtonContainer: document.getElementById(APPLY_CHANGES_PORTAL_SELECTOR)
    };
  }
  componentDidMount() {
    if (!this.state.applyChangesButtonContainer) {
      const applyChangesButtonContainer = document.createElement('div');
      applyChangesButtonContainer.setAttribute('id', APPLY_CHANGES_PORTAL_SELECTOR);
      document.body.appendChild(applyChangesButtonContainer);
      this.setState({
        applyChangesButtonContainer
      });
    }
  }

  // Note, used in non-Baymax only

  render() {
    const {
      activePanel,
      children,
      isOpen,
      isReadOnlyMode,
      headerLabel
    } = this.props;
    return /*#__PURE__*/_jsx(AppReadyContainer, {
      children: /*#__PURE__*/_jsx(Sidebar, {
        isOpen: isOpen,
        activePanel: activePanel,
        onClose: this.handleClose,
        isReadOnlyMode: isReadOnlyMode,
        headerLabel: headerLabel,
        children: children
      })
    });
  }
}
SidebarContainer.propTypes = {
  children: PropTypes.node.isRequired,
  activePanel: PropTypes.string.isRequired,
  selectedModuleName: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clearInpageUIState: PropTypes.func.isRequired,
  currentStep: PropTypes.string.isRequired,
  routeToPage: PropTypes.func.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  hasAnyContainerOrDndAreaToAddModules: PropTypes.bool.isRequired,
  headerLabel: PropTypes.node
};
export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer);